<template lang="pug">
.income-list-page.flex.column.align-center
  .content.flex.column.align-stretch.pt-40.gap-20
    .title.font-size-20.bold 對帳歷史紀錄
    .empty.text-secondary(v-if="loaded && list.length === 0") 目前沒有可查詢的對帳月份
    .years.flex.column.gap-20
      .year.flex.column.gap-8(v-for="l in list", :key="l.year")
        .year-title.flex.row.align-center.pl-12.pr-12.gap-8.clickable(
          @click="toggleShow(l)")
          i.el-icon-date
          span {{ l.year }}
        template(v-if="l.show")
          .month.flex.row.align-center.pl-12.pr-12.clickable(
            @click="goAccountMonth(d)"
            v-for="d in l.data")
            .content.bold {{ d.year }}年 {{ d.month }}月
</template>

<script>
import { getCurrentYearMonth } from '@/site/professional/api/accounting';

// 對帳紀錄最早從 2024 年 1 月開始
const FIRST_YEAR = 2024;

export default {
  data() {
    return {
      list: [],
      loaded: false,
    };
  },
  methods: {
    goAccountMonth(d) {
      this.$router.push(`/income/${d.year}/${d.month}`);
    },
    toggleShow(l) {
      // eslint-disable-next-line no-param-reassign
      l.show = !l.show;
      this.$forceUpdate();
    },
    loadData() {
      this.$execWithLoading(async () => {
        const yearMap = {};
        const list = [];
        // 以伺服器時間為準計算目前月份，不依賴裝置時間
        let { year, month } = await getCurrentYearMonth();
        while (year >= FIRST_YEAR) {
          if (!yearMap[year]) {
            const l = {
              year,
              data: [],
              show: true,
            };
            list.push(l);
            yearMap[year] = l;
          }
          yearMap[year].data.push({ year, month });

          month -= 1;
          if (month < 1) {
            month = 12;
            year -= 1;
          }
        }
        this.list = list;
        this.loaded = true;
      });
    },
  },
  mounted() {
    this.loadData();
  },
};
</script>

<style lang="scss" scoped>
.income-list-page {
  .content {
    width: calc(100vw - 40px);
    max-width: 600px;
    .years {
      .year-title {
        flex: 0 0 40px;
        background: white;
        border-radius: 4px;
      }
      .month {
        flex: 0 0 40px;
        background: white;
        border-radius: 4px;
      }
    }
  }
}
</style>
